(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    const nodes = root.querySelectorAll('[data-partner-reveal]');
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    nodes.forEach((el) => io.observe(el));
  }

  function initStepHover(root) {
    if (reduce || window.matchMedia('(pointer: coarse)').matches) return;
    root.querySelectorAll('.partner-card, .partner-track').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = `translateY(-6px) rotateX(${(-y * 3).toFixed(2)}deg) rotateY(${(x * 4).toFixed(2)}deg)`;
      });
      card.addEventListener('pointerleave', () => {
        card.style.transform = '';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-partner-page]');
    if (!root) return;
    initReveals(root);
    initStepHover(root);
  });
})();
